<script setup>
import { useToasts } from '@/composables/useToast'

const state = useToasts()
</script>

<template>
  <teleport to="body">
    <transition-group
      name="toast-fade"
      tag="div"
      class="fixed left-0 right-0 z-[60] mx-auto overflow-hidden text-center top-10 max-w-[40rem]"
    >
      <div
        v-for="toast in state.toasts"
        :key="toast.id"
        class="inline-flex items-center justify-center px-4 py-3 mb-4 text-sm font-medium text-white rounded-md bg-n-slate-12 dark:bg-n-slate-7 drop-shadow-md min-w-[22rem] max-w-[40rem]"
      >
        {{ toast.message }}
      </div>
    </transition-group>
  </teleport>
</template>
